import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { Delete } from "@material-ui/icons";

const PreviewContainer = ({ imageUrl, onRemove }) => {
  return (
    <div className="previewContainer">
      <img width={32} height={32} src={imageUrl} alt="Selected" />
      <div className="actions">
        <Button variant="secondary" size="sm" onClick={() => onRemove("")}>
          <Delete fontSize="small" />
        </Button>
      </div>
    </div>
  );
};

const FileUploader = ({ uploadFileData, setFileUrl, setLoadingState }) => {
  return (
    <Form.Control
      type="file"
      accept="image/png, image/jpg, image/jpeg"
      size="sm"
      onChange={async (event) => {
        setLoadingState(true);
        const [file] = event.target.files;
        const fileName = await uploadFileData(file, "unselected");
        if (fileName) {
          setFileUrl(fileName);
        }
        setLoadingState(false);
      }}
    />
  );
};
const AddColorSlot = ({
  showModal,
  onCloseColorSlot,
  onUploadColorIcon,
  onSaveSlotData,
}) => {
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);
  const [iconSelected, setIconSelected] = useState("");
  const [iconUnSelected, setIconUnSelected] = useState("");
  return (
    <Modal
      show={showModal}
      onHide={onCloseColorSlot}
      backdrop="static"
      contentClassName="colorSlotContent"
      dialogClassName="colorSlotDialog"
      backdropClassName="colorSlotBackDrop"
    >
      {loading && (
        <div className="loadingModalOverlay">
          <div className="loadingContainer">
            <div className="loader" />
          </div>
        </div>
      )}
      <Modal.Header closeButton closeVariant="white">
        <Modal.Title>Add New Color</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group controlId="formFileSm">
          <Form.Label>Color Name</Form.Label>
          <Form.Control
            size="sm"
            type="text"
            placeholder="Color Name"
            value={name}
            onChange={(event) => setName(event.target.value)}
          />
          <Form.Label>Icon Selected</Form.Label>
          {!iconSelected ? (
            <FileUploader
              uploadFileData={onUploadColorIcon}
              setFileUrl={setIconSelected}
              setLoadingState={setLoading}
            />
          ) : (
            <PreviewContainer
              imageUrl={iconSelected}
              onRemove={setIconSelected}
            />
          )}
          <Form.Label>Icon Un-Selected</Form.Label>
          {!iconUnSelected ? (
            <FileUploader
              uploadFileData={onUploadColorIcon}
              setFileUrl={setIconUnSelected}
              setLoadingState={setLoading}
            />
          ) : (
            <PreviewContainer
              imageUrl={iconUnSelected}
              onRemove={setIconUnSelected}
            />
          )}
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button size="sm" variant="secondary" onClick={onCloseColorSlot}>
          Cancel
        </Button>
        <Button
          size="sm"
          variant="primary"
          onClick={() => {
            const data = {
              name,
              iconSelected,
              icon: iconUnSelected,
              default: 0,
              menu: [],
            };
            onSaveSlotData(data);
            onCloseColorSlot();
          }}
        >
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AddColorSlot;
